import type {CutForestMass} from '@/domain/entities/Op';
import type {ForestMassRepository} from '@/domain/interfaces/ForestMassRepository';
import type {ForestMassStatusesRepository} from '@/domain/interfaces/ForestMassStatusesRepository';
import type {OpRepository} from '@/domain/interfaces/OpRepository';

export class OpCutForestMassUseCase {
  constructor(
    private readonly opRepository: OpRepository,
    private readonly forestMassRepository: ForestMassRepository,
    private readonly forestMassStatusesRepository: ForestMassStatusesRepository,
  ) {}
  execute = async (domain: CutForestMass) => {
    await this.opRepository.cutForestMass(domain);
    const forestMass = await this.forestMassRepository.getById(domain.forestMassUuid);
    const forestMassStatuses = await this.forestMassStatusesRepository.getAll();
    return {forestMass, forestMassStatuses};
  };
}
